import { createAction, props, union } from '@ngrx/store';
import { LilateList } from '../../model/lilate.model';
import { HttpParams } from '@angular/common/http';

export enum LilateActionTypes {
    GET_LISTING = '[LILATE] Get LISTING',
    GET_LISTING_URL = '[LILATE] Get LISTING URL',
    GET_LIST_PAST = '[LILATE] Get List Past',
    GET_LIST_UPCOMING = '[LILATE] Get List Upcoming',
    GET_LIST_SUCCESS = '[LILATE] Get LIST Success',
    GET_LIST_FAILURE = '[LILATE] Get LIST Failure',
    GET_LISTING_SUCCESS = '[LILATE] Get LISTING Success',
    GET_LISTING_FAILURE = '[LILATE] Get LISTING Failure',
    PATCH_LILATE = '[LILATE] Patch lilate',
    PATCH_SUCCESS = '[LILATE] Update Success',
    PATCH_FAILURE = '[LILATE] Update Failure',
    PLAN_LILATE = '[LILATE] Plan lilate',
    PLAN_SUCCESS = '[LILATE] Plan Success',
    PLAN_FAILURE = '[LILATE] Plan Failure',
}

export const GetLilatesPast = createAction(
    LilateActionTypes.GET_LIST_PAST,
)

export const GetLilatesUpcoming = createAction(
    LilateActionTypes.GET_LIST_UPCOMING,
    props<{ params: HttpParams }>()
)

export const GetLilatesSuccess = createAction(
    LilateActionTypes.GET_LIST_SUCCESS,
    (payload: LilateList, upcoming: boolean) => ({ payload, upcoming })
)

export const GetLilatesFailure = createAction(
    LilateActionTypes.GET_LIST_FAILURE,
)

export const PatchLilate = createAction(
    LilateActionTypes.PATCH_LILATE,
    (params: any, id: number, plan: boolean, teacher?: number) => ({ params, id, plan, teacher })
)

export const PatchSuccess = createAction(
    LilateActionTypes.PATCH_SUCCESS,
)

export const PatchFailure = createAction(
    LilateActionTypes.PATCH_FAILURE,
)

export const PlanLilate = createAction(
    LilateActionTypes.PLAN_LILATE,
    (id: number, teacher?: number) => ({ id, teacher })
)

export const PlanSuccess = createAction(
    LilateActionTypes.PLAN_SUCCESS,
)

export const PlanFailure = createAction(
    LilateActionTypes.PLAN_FAILURE,
)

export const GetLilatesListing = createAction(
    LilateActionTypes.GET_LISTING,
    props<{ params: HttpParams }>()
)

export const GetLilatesListingfromurl = createAction(
    LilateActionTypes.GET_LISTING_URL,
    props<{ url: string }>()
)

export const GetLilatesListingSuccess = createAction(
    LilateActionTypes.GET_LISTING_SUCCESS,
    props<{ payload: LilateList }>()
)

export const GetLilatesListingFailure = createAction(
    LilateActionTypes.GET_LISTING_FAILURE,
)

const actions = union({
    GetLilatesUpcoming,
    GetLilatesSuccess,
    GetLilatesFailure,
    GetLilatesPast,
    PatchLilate,
    PatchSuccess,
    PatchFailure,
    PlanLilate,
    PlanSuccess,
    PlanFailure,
    GetLilatesListing,
    GetLilatesListingfromurl,
    GetLilatesListingSuccess,
    GetLilatesListingFailure
});

export type LilateActionsUnions = typeof actions;